<script lang="ts">
import { defineComponent } from 'vue';
import ErrorBox from './ErrorBox.vue';

export default defineComponent({
	components: {},
	extends: ErrorBox,
	data() {
		const color = 'main';
		const name = 'icon:info';
		const isInfoBox = true;

		return {
			isInfoBox,
			name,
			color
		};
	}
});
</script>

<style lang="scss" scoped>
.info-box {
	border-radius: 0.5rem;
	border: 1px solid $color-main;
	background-color: $color-main-b;

	h3,
	p {
		color: $color-main;
	}
}
</style>
